import { Injectable, inject } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { EMPTY, Observable, ReplaySubject, map } from 'rxjs';

export type PublicToolbarConfig = {
  showLogin?: boolean;
  showBoth?: boolean;
};

const pathOf = (url: string) => url.split(/[?#]/)[0];

@Injectable({
  providedIn: 'root',
})
export class PublicToolbarService {
  config$: Observable<PublicToolbarConfig> = EMPTY;

  private config: PublicToolbarConfig = {
    showLogin: false,
    showBoth: false,
  };

  private update$ = new ReplaySubject(1);

  constructor() {
    const router = inject(Router);
    // Created lazily (by the toolbar), often after the first navigation.
    let lastPath = pathOf(router.url);

    router.events.subscribe(data => {
      if (data instanceof RoutesRecognized) {
        // Query-param-only changes (list filters, the detail drawer) keep the
        // same page, so they keep the config that page set.
        const path = pathOf(data.urlAfterRedirects);
        const samePage = path === lastPath;
        lastPath = path;
        if (samePage) return;
        if (!data.state.root.firstChild?.data?.['breadcrumbs']) this.clear();
      }
    });

    this.config$ = this.update$.pipe(map(() => this.config));
  }

  set(config: PublicToolbarConfig) {
    this.config = config;
    this.update$.next(1);
  }

  clear() {
    this.config = {
      showLogin: false,
      showBoth: false,
    };
    this.update$.next(1);
  }
}
